import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

export function useBookingCurve(date: string | null, maxDaysOut?: number) {
  return useQuery({
    queryKey: ["booking-curve", date, maxDaysOut],
    queryFn: () => api.pricingNotifications.bookingCurve(date!, maxDaysOut),
    enabled: !!date,
    staleTime: 5 * 60 * 1000,
  });
}
